import { Image, Text, View } from "@react-pdf/renderer";
import styles from "./Styles";
import { SitePhoto } from "../../../models/SitePhoto";
import moment from "moment";

type Props = {
  photo: SitePhoto;
  token: string;
};

const PhotoCard = ({ photo, token }: Props) => {
  return (
    <View style={{ marginBottom: 10 }} wrap={false}>
      {photo.fileUrl ? (
        <Image
          style={{ ...styles.image }}
          src={{
            uri: photo.fileUrl,
            method: "GET",
            headers: { authorization: `Bearer ${token}` },
            body: "",
          }}
        />
      ) : (
        <View
          style={{
            minHeight: 100,
            margin: 5,
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text style={{ fontSize: 20, color: "#999" }}>No Photo</Text>
        </View>
      )}
      <View style={{ paddingHorizontal: 5 }}>
        {photo.type && <Text style={{ fontSize: 9, color: "#666", marginBottom: 2 }}>{photo.type.name}</Text>}
        {photo.affectedServiceName && (
          <Text style={{ fontSize: 9, color: "#2185d0", marginBottom: 2 }}>
            Affected Service: {photo.affectedServiceName}
          </Text>
        )}
        {(photo.dateCreated || photo.createdBy) && (
          <Text style={{ fontSize: 9, color: "#666", marginBottom: 2 }}>
            {photo.dateCreated && moment.utc(photo.dateCreated).local().format("L")}
            {photo.createdBy && ` by ${photo.createdBy.user.displayName}`}
          </Text>
        )}
        <Text style={{ fontSize: 9, color: "#333" }}>
          {photo.noPhotoReason
            ? `No Photo Reason: ${photo.noPhotoReason}`
            : photo.comments
              ? photo.comments
              : "No comment added."}
        </Text>
      </View>
    </View>
  );
};

export default PhotoCard;
